import { PatientHealthSummaryResponse } from '../../../api/getPatientHealthSummary';
import sendToSlack from '../../../api/sendToSlack';
import { getDoc } from '../../../store/idbHandler';
import { isForProd } from '../../../api/constants';
import { track } from '../../../tracking';
import { notification } from 'antd';

export const colorObject: {
    [k: string]: {
        color: string;
        background: string;
    };
} = {
    red: {
        color: '#D74B41',
        background: '#FBEDEC',
    },
    orange: {
        color: '#8E6807',
        background: '#FDF7E7',
    },
    white: {
        color: '#484848',
        background: '#E8E8E8',
    },
};

export const getIsPatientHealthSummaryPresent = (
    patientHealthSummary?: PatientHealthSummaryResponse,
): boolean => {
    if (!patientHealthSummary) return false;
    const isTagsPresent = patientHealthSummary.tags?.length > 0;
    const isUpdatesPresent = patientHealthSummary.updates_in_last_visit?.length > 0;
    return isTagsPresent || isUpdatesPresent;
};

export const sendFeedbackToSlack = (
    type: string,
    patientId: string,
    input: string,
    from: string,
): void => {
    const doc = getDoc();
    const docId = doc?._id || 'NA';
    const docName = [doc?.profile?.personal?.name?.f, doc?.profile?.personal?.name?.l]
        .filter(Boolean)
        .join(' ');
    notification.success({
        message: 'Thanks for your feedback 👍.',
        duration: 5,
    });
    track('HEALTH_SUMMARY_FEEDBACK', { type, patientId, input, from });
    let text = '';
    const pId = patientId || 'NA';
    if (type === 'positive') {
        text = `🥳 Positive feedback received from Dr. ${docName}. [${isForProd ? 'prod' : 'dev'}]`;
    } else {
        text = `🚨 Negative feedback received from Dr. ${docName}. [${isForProd ? 'prod' : 'dev'}]`;
    }
    text += `\nPatient: ${pId} | Doctor: ${docId}`;
    text += `\nhttp://opera-house.orbi.orbi/doctool/summary/?doc_oid=${docId}&pt_oid=${pId}`;
    text += `\nFrom: ${from}`;
    if (input?.trim().length) {
        text += `\nRemarks: ${input.trim()}`;
    }
    sendToSlack({
        key: 'health-summary-feedback',
        payload: [
            {
                blocks: [
                    {
                        type: 'section',
                        text: {
                            type: 'mrkdwn',
                            text: text,
                        },
                    },
                ],
            },
        ],
    });
};

export type FeedbackType = 'positive' | 'negative' | 'skip';
